module.exports = __webpack_public_path__ + "img/ico_search--white.b9c699a5.svg";